<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/projects/overview']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PPS <cds-icon shape="two-way-arrows"></cds-icon> Neues Projekt für Kunde {{ companyId }} initialisieren</h2>
  <p class="opener" cds-text="section">Projekte sind der Ausgangspunkt für die Abwicklung Ihrer Kundenaufträge. <br>Von hier aus organisieren Sie Ihre Lieferantenanfragen, Angebote bis hin zur Rechnung.</p><br>

  <app-project-form [companyId]="companyId" [employeePhm]="employeePhm" (formSubmit)="onProjectAdded($event)"></app-project-form>
</main>
